import e from "react";
import { Layout as l } from "antd";
import t from "./menu.js";
import r from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import "../scrollbar/index.scss.js";
import "./index.scss.js";
export default (function (_ref) {
  var s = _ref.collapsed,
      a = _ref.isMobile,
      o = _ref.logoUrl,
      m = _ref.menus,
      c = _ref.name,
      n = _ref.onCollapseChange;
  return e.createElement(l.Sider, {
    width: a ? 200 : 256,
    theme: "light",
    breakpoint: "lg",
    trigger: null,
    collapsible: !0,
    collapsed: s,
    onBreakpoint: a ? n : function () {},
    className: "slider"
  }, e.createElement("div", {
    className: "brand"
  }, e.createElement("div", {
    className: "logo"
  }, e.createElement("img", {
    alt: "logo",
    src: o || ""
  }), s ? null : e.createElement("h1", null, c || ""))), e.createElement("div", {
    className: "menuContainer"
  }, e.createElement(r, {
    options: {
      suppressScrollX: !0
    }
  }, e.createElement(t, {
    menus: m,
    theme: "light",
    isMobile: a,
    collapsed: s,
    onCollapseChange: n
  }))));
});